import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { parcelExceptionsOptions } from './constants'

const ParcelExceptionsSelector = ({ onChange, value }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Alertas pendientes')}
      menuItems={parcelExceptionsOptions.map(o => ({ ...o, label: t(o.label) }))}
      handleChange={e => onChange(e.target.value)}
      value={value}
      fullWidth
    />
  )
}

export default ParcelExceptionsSelector
